// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1pAzK","title":"Info_title__98tWT","links":"Info_links__39iOT","link":"Info_link__1PR3n","logo":"Info_logo__H0Dvf"};